/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
import React from "react";
export const SvgRemove: React.FC<React.SVGAttributes<SVGElement>> = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill="currentColor"
                d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.5a8.5 8.5 0 10.001 17.001A8.5 8.5 0 0012 3.5zm3.25 7.75a.75.75 0 010 1.5h-6.5a.75.75 0 010-1.5h6.5z"
            />
            <path d="M0 0h24v24H0z" />
        </g>
    </svg>
);
